<div class="login">
  <img src="./assets/images/logo.svg" alt="logo" class="logo" />
  <h2 id="BoLoginPageTitleLbl">{{ 'LOGIN_WELCOME_TITLE' | translate }}</h2>
  <p>
    {{ 'LOGIN_WELCOME_TEXT' | translate }}
  </p>
  <form [formGroup]="form" role="form" novalidate>
    <mat-form-field class="form-group selector-small">
      <mat-select [(value)]="currentLanguage" id="BoLoginLanguageBtn" (valueChange)="changeLanguage(currentLanguage)">
        <mat-option *ngFor="let language of allLanguages" value="{{ language }}">
          <img [src]="'assets/flags/' + language + '.png'" /> {{ language }}
        </mat-option>
      </mat-select>
      <span matPrefix><img [src]="'assets/flags/' + currentLanguage + '.png'" />&#160;</span>
    </mat-form-field>

    <div class="bottom">
      <button mat-button type="submit" id="BoLoginConnectionBtn" class="btn-primary" (click)="login()">
        {{ 'LOGIN_BUTTON' | translate }}
      </button>
    </div>

    <div>
      {{ 'LOGIN_INFO' | translate }}
    </div>
  </form>
</div>
<!--iframe for delete old storage (data login)-->
<iframe id="myIFrame" [attr.src]="urlOldBO" *ngIf="urlOldBO" title="iframeOldBOForRemoveStorage"></iframe>
